import { DownloadPayrollBreakdownModal } from "./DownloadPayrollBreakdownModal"
import { PayrollStateTypeEnum } from "@oysterhr/schema"
import { useMemo } from "react"
import { useCompanyPayrollDownloads } from "./hooks/useCompanyPayrollDownloads"

interface Props {
  setShowModal: (show: boolean) => void
  companyId: string
  period: string
}

export function DownloadPayrollBreakdown({ companyId, period, setShowModal }: Props) {
  const [year, month] = period.split("-").map(Number)
  const { data, loading } = useCompanyPayrollDownloads({
    companyId,
    year,
    month,
  })

  const onDownloadPayrollBreakdown = useMemo(() => {
    const state = data?.company?.payroll?.state
    const file = data?.company?.payroll?.settlementInvoice?.supportingFile?.url
    if (state === PayrollStateTypeEnum.Completed && file) {
      return () => window.open(file)
    }

    return undefined
  }, [data])

  const onDownloadPrefundingBreakdown = useMemo(() => {
    const file = data?.company?.payroll?.preFundingInvoice?.supportingFile?.url
    if (file) {
      return () => window.open(file)
    }

    return undefined
  }, [data])

  return (
    <DownloadPayrollBreakdownModal
      loading={loading}
      setShowModal={setShowModal}
      onDownloadPrefundingBreakdown={onDownloadPrefundingBreakdown}
      onDownloadPayrollBreakdown={onDownloadPayrollBreakdown}
    />
  )
}
